'use client'

import { Button } from '@/core/ui/atoms/button'
import { FormInput } from '@/core/ui/forms/input'
import { Link, usePathname } from '@/i18n/navigation'
import { CornerUpLeft } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'
import { FormProvider } from 'react-hook-form'
import { useForgotPassword } from './use-forgot-password'

type Props = {
  onSuccess: () => void
}

export const ForgotPasswordForm: React.FC<Props> = props => {
  const t = useTranslations()
  const { form, handleSubmit, isPending } = useForgotPassword(props)
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const getSigninLink = () => {
    const params = new URLSearchParams(searchParams)
    params.set('auth', 'login')
    return `${pathname}?${params.toString()}`
  }
  return (
    <div className='px-1 py-3 sm:px-10 sm:py-5'>
      <div className='mb-3 flex items-center gap-3 sm:gap-6'>
        <Link href={getSigninLink()}>
          <CornerUpLeft className='h-5 w-5 cursor-pointer text-gray-700' />
        </Link>
        <h1 className='text-mountain-bluebird text-xl font-semibold sm:text-[28px]'>
          {t('forgotPassword.title')}
        </h1>
      </div>

      <p className='text-mountain-bluebird mb-6 text-base sm:text-lg'>
        {t('forgotPassword.subtitle')}
      </p>

      <FormProvider {...form}>
        <form onSubmit={handleSubmit} className='space-y-4'>
          <FormInput
            name='email'
            label={t('forms.emailLabel')}
            placeholder={t('forms.emailPH')}
            control={form.control}
          />

          <Button
            loading={isPending}
            color='creamed-cron'
            className='mt-5 h-12 w-full font-semibold text-white sm:py-3'
          >
            {t('actions.continue')}
          </Button>

          <Link
            href={getSigninLink()}
            className='text-cyan-blue text-sm underline sm:text-base'
          >
            {t('forgotPassword.returnToSignIn')}
          </Link>
        </form>
      </FormProvider>
    </div>
  )
}
